class RotatingCollection extends HTMLElement{
    constructor(){
        super();
        this.display();
    }

    display(){
        var elements=document.querySelectorAll("div[id='hiddendisplay']");
        elements.forEach((element) => {
            element.toggleAttribute("hidden");
        });

    }
}

customElements.define('rotating-collection', RotatingCollection);